import { AimsCommonTableHeader, AimsCommonTableHeaderType, AimsCommonTablePermissions, TableRowUpdate } from '@aims/common-components';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, type OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service'
import { InvTravelerStatus } from 'src/models';

@Component({
  selector: 'app-traveler-config',
  templateUrl: './travelerConfig.component.html',
  styleUrls: [ './travelerConfig.component.css' ],
})
export class TravelerConfigComponent implements OnInit {

  constructor(private transferHttp: TransferHttpService) {}

  travelerStatuses: Array<InvTravelerStatus>; // = this.transferHttp.getSingle('Inventory/GetInvTravelerStatuses');

  //Spinner
  spinnerText: string = 'Loading...';
  showSpinner: boolean = true;

  travelerStatusTableColumns: AimsCommonTableHeader[] = [
    { key: 'edit', label: 'Edit', type: AimsCommonTableHeaderType.EDIT_BUTTON, filter: false, },
    { key: 'statusCode', label: 'Status Code', type: 'string', width: 60, validatorOrOpts: [Validators.required, Validators.maxLength(3), Validators.minLength(3)],
      events: { filterAndSort: (element) =>  element.statusCode } },
    { key: 'status', label: 'Status', type: 'string', validatorOrOpts: [Validators.required, Validators.maxLength(20)] },
  ]

  travelerStatusTablePermissions: AimsCommonTablePermissions = {
    create: true,
    update: true,
    delete: false,
    export: false,
  }
  initialTravelerStatusTableObject = new InvTravelerStatus();

  handleTravelerStatusRowUpdate(update: TableRowUpdate): void {
    const updatedTravelerStatus: InvTravelerStatus = update.newRow as InvTravelerStatus;
    this.spinnerText = "Saving...";
    this.showSpinner = true;
    this.transferHttp.put('Inventory/SaveInvTravelerStatus', updatedTravelerStatus).subscribe({
      complete: () =>  {
        this.showSpinner = false;
        this.refreshTravelerStatus();
      }
    });
  }

  handleTravelerStatusRowCreate(update: TableRowUpdate): void {
    const updatedTravelerStatus: InvTravelerStatus = update.newRow as InvTravelerStatus;
    this.spinnerText = "Saving...";
    this.showSpinner = true;
    this.transferHttp.put('Inventory/CreateInvTravelerStatus', updatedTravelerStatus).subscribe({
      complete: () =>  {
        this.showSpinner = false;
        this.refreshTravelerStatus();
      }
    });
  }

  refreshTravelerStatus() {
    this.spinnerText = "Loading...";
    this.showSpinner = true;
    this.transferHttp.getSingle('Inventory/GetInvTravelerStatuses').subscribe({
      next: ret => {
        this.travelerStatuses = ret;
      },
      complete: () => {
        this.showSpinner = false;
      }
    });
  }

  ngOnInit(): void {
    this.refreshTravelerStatus();
  }

}
